import { selectSim,insertSim,updateRemarks,importSim,abandonedSim,deleteSim } from "../../api/config/modules/SIMFile";

const state = {
    selectSim: {},
    insertSim: {},
    updateRemarks: {},
    importSim: {},
    abandonedSim: {},
    deleteSim: {}
};

const mutations = {
  SET_SELECTSIM: (state, selectSim) => {
    state.selectSim = selectSim;
  },
  SET_INSERTSIM: (state, insertSim) => {
    state.insertSim = insertSim;
  },
  SET_UPDATEREMARKS: (state, updateRemarks) => {
    state.updateRemarks = updateRemarks;
  },
  SET_IMPORTSIM: (state, importSim) => {
    state.importSim = importSim;
  },
  SET_ABANDONEDSIM: (state, abandonedSim) => {
    state.abandonedSim = abandonedSim;
  },
  SET_DELETESIM: (state, deleteSim) => {
    state.deleteSim = deleteSim;
  },
};

const actions = {
  GET_SELECTSIM: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectSim(data)
        .then((res) => {
          commit("SET_SELECTSIM", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTSIM: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertSim(data)
        .then((res) => {
          commit("SET_INSERTSIM", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEREMARKS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateRemarks(data)
        .then((res) => {
          commit("SET_UPDATEREMARKS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_IMPORTSIM: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        importSim(data)
        .then((res) => {
          commit("SET_IMPORTSIM", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ABANDONEDSIM: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        abandonedSim(data)
        .then((res) => {
          commit("SET_ABANDONEDSIM", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETESIM: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteSim(data)
        .then((res) => {
          commit("SET_DELETESIM", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
